import React, {useEffect, useState} from "react";
import {Divider} from "@mui/material";
import i18n, {t} from "i18next";
import {WeightUnit} from "../../models";

export interface DeliveryMethodsListProps {
    deliveryMethods: any[],
    weight: string | null,
    weightUnit: WeightUnit | null;
    sort: boolean;
}

export const sortMethods = (methods: any[], sort: boolean) => {
    if (methods)
        return methods?.sort((a, b) => {
            if (!sort)
                return a?.totalAmount - b?.totalAmount
            else
                return b?.totalAmount - a?.totalAmount
        })
    return []
}

export default function DeliveryMethodsList({
                                                deliveryMethods: providedDeliveryMethods,
                                                weight: providedWeight,
                                                weightUnit,
                                                sort
                                            }: DeliveryMethodsListProps) {

    const [deliveryMethods, setDeliveryMethods] = useState<any[] | null>(sortMethods(providedDeliveryMethods, sort))


    const renderTransportationMethod = (transportationMethod: string) => {
        if (transportationMethod && transportationMethod?.toLowerCase()?.includes("air"))
            return <div className={'icon-box'}><img
                src={'https://trtshopping.com/wp-content/uploads/2023/06/air-mode.svg'} alt={''}/></div>
        else if (transportationMethod &&
            (transportationMethod?.toLowerCase()?.includes("ocean") || transportationMethod?.toLowerCase()?.includes("sea"))
        )
            return <div className={'icon-box'}><img
                src={'https://trtshopping.com/wp-content/uploads/2023/06/ocean-mode.svg'} alt={''}/></div>
        return <div className={'icon-box'}><img
            src={'https://trtshopping.com/wp-content/uploads/2023/06/air-mode.svg'} alt={''}/></div>
    }

    const renderCarrier = (carrierName: string) => {
        if (carrierName && ((carrierName.includes("Nova") && (carrierName.includes("Poshta") || carrierName.includes("Pochta"))) || carrierName.includes("NP")))
            return <div className={'icon-box'}><img
                src={'https://trtshopping.com/wp-content/uploads/2023/06/carrier-nova-poshta.svg'} alt={''}/></div>
        else if (carrierName && carrierName.includes("Ukr") && (carrierName.includes("Poshta") || carrierName.includes("Pochta")))
            return <div className={'icon-box'}><img
                src={'https://trtshopping.com/wp-content/uploads/2023/06/carrier-ukrposhta.svg'} alt={''}/></div>
        return <div className={'icon-box'}><img
            src={'https://trtshopping.com/wp-content/uploads/2023/07/carrier.svg'} width={30} alt={''}/></div>
    }

    useEffect(() => {
        if (providedDeliveryMethods)
            setDeliveryMethods(sortMethods(providedDeliveryMethods, sort))
    }, [providedDeliveryMethods, sort])

    return <div className={'delivery-methods'}>
        {deliveryMethods?.map((deliveryMethod, index) => {
                if (deliveryMethod?.totalAmount && deliveryMethod?.totalAmount > 0)
                    return <>
                        <div className={'delivery-method'}>
                            <div
                                className={'delivery-method-transportation-carrier'}
                            >
                                <div className={'icons'}>
                                    {renderTransportationMethod(deliveryMethod?.rate?.customValues["service_description_en"] ?? "")}
                                    {renderCarrier(deliveryMethod?.rate?.customValues["service_description_en"] ?? "")}
                                </div>
                                <div className={'carrier-name'}>{/*deliveryMethod?.carrier?.name*/}</div>
                                <Divider orientation="vertical" variant="middle" flexItem/>
                            </div>
                            <div
                                className={'delivery-method-method-rate'}
                            >
                                <div>{deliveryMethod?.rate?.customValues?.["service_description_" + i18n.language ?? 'en']}
                                    {' - '}

                                    {t('deliveryMethods.from')}{' '}
                                    {deliveryMethod?.rate?.transitDaysMin}
                                    {' '}{t('deliveryMethods.upto')}{' '}
                                    {deliveryMethod?.rate?.transitDaysMax}
                                    {' '}
                                    {t('deliveryMethods.days')}
                                </div>
                                {
                                    deliveryMethod ? <div
                                            className={'delivery-method-rate'}>
                                            {deliveryMethod?.currencySymbol ?? "$"}{deliveryMethod?.totalAmount?.toFixed(2)}
                                        </div> :
                                        <div
                                            className={'delivery-method-rate'}>
                                            ${} {t('deliveryMethods.for')} {weightUnit ? t('weight.' + weightUnit?.toLowerCase()) : t('weight.kg')}
                                        </div>
                                }

                            </div>
                        </div>

                        {deliveryMethods?.length - 1 > index ?
                            <Divider flexItem/> : null}
                    </>
            }
        )}
    </div>
}